// The Aithlo mark, filled, from the master in the engineering repo (`python
// brand/generate.py --check` prints this path). Its stroke comes to about 2 px
// at 24 px, so it sits with lucide's nav icons, and it takes their colour
// (active, hover). Mobile's components/icons/AithloIcon.tsx draws the same path.
import React from 'react';

export const AITHLO_ICON_PATH = 'M234.29 109.76A22.01 22.01 0 0 1 271.83 109.76L329.79 204.33A8.00 8.00 0 0 1 329.79 212.69L315.70 235.67A8.00 8.00 0 0 1 302.06 235.67L258.52 164.64A6.40 6.40 0 0 0 247.60 164.64L101.45 403.09A6.40 6.40 0 0 0 106.90 412.84L225.59 412.84A6.40 6.40 0 0 0 231.05 409.78L327.55 252.33A22.01 22.01 0 0 1 365.09 252.33L467.46 419.35A22.01 22.01 0 0 1 448.69 452.86L63.31 452.86A22.01 22.01 0 0 1 44.54 419.35ZM340.86 307.21A6.40 6.40 0 0 1 351.78 307.21L410.55 403.09A6.40 6.40 0 0 1 405.09 412.84L287.55 412.84A6.40 6.40 0 0 1 282.10 403.09Z';

const AithloIcon = React.forwardRef(({ size = 24, className, ...props }, ref) => (
  <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 512 512"
    fill="currentColor" fillRule="evenodd" className={className} aria-hidden="true" {...props}>
    <path d={AITHLO_ICON_PATH} />
  </svg>
));
AithloIcon.displayName = 'AithloIcon';

export default AithloIcon;
